<template>
  <!-- 路由编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="活动ID: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="16">
            <el-input
              v-model="detailId"
              :disabled="detailId!=''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="活动名称: "
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.title"
              :disabled="isStatus=='0'||isView"
              autocomplete="off"
              maxlength="200"
              show-word-limit
              placeholder="请输入活动名称"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="简介: " prop="meta" :label-width="formLabelWidth">
          <el-col :span="24">
            <el-input
              type="textarea"
              v-model="form.meta"
              :disabled="isStatus=='0'||isView"
              autocomplete="off"
              maxlength="200"
              show-word-limit
              placeholder="请输入简介"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="封面图:"
          ref="uploadPic"
          prop="uploadPic"
          class="div-upload-form-item address"
          :label-width="formLabelWidth"
        >
          <div class="div-upload-container">
            <el-upload
              ref="uploadfiles1"
              accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
              list-type="picture-card"
              action=""
              multiple
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :before-upload="handleBefore"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议比例: W: H=5:3  建议尺寸:W*H=640*400 (px)</div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="详 情:" prop="content" :label-width="formLabelWidth">
          <el-col :span="24">
            <tinymce
              styleName="width: 100%; height: 400px; margin: 5px auto; "
              id="tinymceId"
              @onChange="onChange"
              :disabled="isStatus=='0'||isView"
              :key="tinymceFlag"
              :text="form.content"
              :url="form.newUrlStr"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="作 者:"
          prop="author"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.author"
              :disabled="isStatus=='0'||isView"
              placeholder="请输入作者"
              autocomplete="off"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="发布机构:"  :label-width="formLabelWidth">
          <el-checkbox-group @change="handleRefresh" v-model="form.instititionArray">
            <el-row :gutter="15">
              <el-col :span="6" style="padding-left: 0"
                ><el-checkbox label="7" :disabled="isStatus=='0'||isView">学术委员会</el-checkbox></el-col
              >
              <el-col :span="6" style="padding-left: 0"
                ><el-checkbox label="8" :disabled="isStatus=='0'||isView">秘书处</el-checkbox></el-col
              >
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6"
                ><el-checkbox label="5" :disabled="isStatus=='0'||isView">语文辞书专业委员会</el-checkbox></el-col
              >
              <el-col :span="6"
                ><el-checkbox label="6" :disabled="isStatus=='0'||isView">专科辞书专业委员会</el-checkbox></el-col
              >
              <el-col :span="6"
                ><el-checkbox label="4" :disabled="isStatus=='0'||isView">双语辞书专业委员会</el-checkbox></el-col
              >
              <el-col :span="6"
                ><el-checkbox label="2" :disabled="isStatus=='0'||isView">百科全书专业委员会</el-checkbox></el-col
              >
            </el-row>
            <el-row :gutter="15">
              <el-col :span="5"
                ><el-checkbox label="9" :disabled="isStatus=='0'||isView">民族辞书专业委员会</el-checkbox></el-col
              >
              <el-col :span="7"
                ><el-checkbox label="3" :disabled="isStatus=='0'||isView"
                  >辞书理论与辞书史专业委员会</el-checkbox
                ></el-col
              >
              <el-col :span="6"
                ><el-checkbox label="10" :disabled="isStatus=='0'||isView"
                  >辞书编撰现代化专业委员会</el-checkbox
                ></el-col
              >
              <el-col :span="6"
                ><el-checkbox label="1" :disabled="isStatus=='0'||isView"
                  >辞书编辑出版专业委员会</el-checkbox
                ></el-col
              >
            </el-row>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="显示位置:"
          prop="newsSortList"
          :label-width="formLabelWidth"
        >
          <el-checkbox-group  v-model="form.newsSortList">
            <el-row :gutter="15">
              <el-col :span="6" style="padding-left: 0"
                ><el-checkbox label="1" :disabled="isStatus=='0'||isView">学会简介</el-checkbox></el-col
              >
              <el-col :span="6" style="padding-left: 0"
                ><el-checkbox label="2" :disabled="isStatus=='0'||isView">学会章程</el-checkbox></el-col
              >
            </el-row>
            <el-row :gutter="15" >
              <el-col :span="6"
                ><el-checkbox label="3" :disabled="isStatus=='0'||isView">学会资讯</el-checkbox
                >
                <el-input
                  v-model="addressSort3"
                  :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              />
              </el-col>
              <el-col :span="6"
                ><el-checkbox label="4" :disabled="isStatus=='0'||isView">会议通知</el-checkbox
                ><el-input
                  :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort4"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
              <el-col :span="6"
                ><el-checkbox label="5" :disabled="isStatus=='0'||isView">学术研讨</el-checkbox
                ><el-input
                  :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort5"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
              <el-col :span="6"
                ><el-checkbox label="6" :disabled="isStatus=='0'||isView">专题活动</el-checkbox
                ><el-input
                  :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort6"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6"
                ><el-checkbox label="7" :disabled="isStatus=='0'||isView">辞书出版</el-checkbox
                ><el-input
                :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort7"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
              <el-col :span="6"
                ><el-checkbox label="8" :disabled="isStatus=='0'||isView">辞书获奖</el-checkbox
                ><el-input
                :disabled="isStatus=='0'||isView"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort8"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
              <el-col :span="6"
                ><el-checkbox label="9" :disabled="isStatus=='0'||isView">辞书展览</el-checkbox
                ><el-input
                :disabled="isStatus=='0'||isView"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort9"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6"
                ><el-checkbox label="15" :disabled="isStatus=='0'||isView">学员文集</el-checkbox
                ><el-input
                  :disabled="isStatus=='0'||isView"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort15"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
              <el-col :span="6"
                ><el-checkbox label="11" :disabled="isStatus=='0'||isView">党建活动</el-checkbox
                ><el-input
                :disabled="isStatus=='0'||isView"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  v-model="addressSort11"
                  placeholder="请输入顺序"
                  size="mini"
                  class="input_style"
              /></el-col>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
         <el-button v-show="isStatus=='0'||isView" class="confirm-button" type="primary" @click="$router.push('/society-activity')"
          >返回列表</el-button
        >
        <el-button :disabled="isStatus=='0'||isView" type="primary" class="confirm-button" @click="handelConfirm('form', 2)">
          预发布
        </el-button>
        <el-button :disabled="isStatus=='0'||isView" class="confirm-button" @click="handelConfirm('form', 1)"
          >保 存</el-button
        >

      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 2)">
          预发布
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Net from '@/constants'
import SocietyActivityApi from '@/api/societyActivity/index.js'
import { mapRequestActions } from '@/utils'
import tinymce from '@/components/richtext-tinymce/richtext-tinymce'
export default {
  components: {
    tinymce
  },
  data () {
    var checkFontNumber = (rule, value, callback) => {
      // let regEn = /^[1-9]\d*$|^[1-9]\d*.\d{1,2}$/;
      var description = value
      description = description.replace(/(\n)/g, '')
      description = description.replace(/(\t)/g, '')
      description = description.replace(/(\r)/g, '')
      description = description.replace(/<\/?[^>]*>/g, '')
      description = description.replace(/\s*/g, '')
      description = description.replace(/&nbsp;/g, '')
      description = description.replace(/\\"/g, '')
      description = description.replaceAll('&ldquo;', '"')
      description = description.replaceAll('&rdquo;', '"')
      description = description.replaceAll('&lsquo;', "'")
      description = description.replaceAll('&rsquo;', "'")
      if (description.length > 60000) {
        // callback(new Error('最多不超过30000字'))
        callback()
      } else {
        callback()
      }
    }
    return {
      loading: false,
      isRemove: true, // 判断上传图片是否删除
      formLabelWidth: '150px',
      isStatus: null,
      radioType: '0',
      dialogVisible: false,
      dialogImageUrl: '',
      detailId: this.$route.query.id || '',
      module: this.$route.query.module || '',
      isView: !!this.$route.query.isView || false,
      detailList: {},
      fileList: [],
      sendFile: [],
      tinymceFlag: 1,
      imageId: '', // 上传封面ID
      linkUrl: '', // 链接
      addressSort1: '',
      addressSort2: '',
      addressSort3: '',
      addressSort4: '',
      addressSort5: '',
      addressSort6: '',
      addressSort7: '',
      addressSort8: '',
      addressSort9: '',
      addressSort11: '',
      addressSort15: '',
      form: {
        title: '',
        meta: '', // 简介
        author: '',
        detail: '',
        content: '', // 富文本内容
        newUrlStr: '', // 新url 富文本图片
        instititionArray: [], // 发布机构
        newsSortList: [] // 发布位置
        // addressSort3: '',
        // addressSort4: ''

      },

      rule: {
        title: [
          { required: true, message: '请输入活动名称', trigger: 'change' },
          {
            min: 1,
            max: 200,
            message: '请输入长度1～200个字符',
            trigger: 'change'
          }
        ],
        uploadPic: [{ required: true, message: '请上传图片', trigger: 'change' }],
        content: [
          { required: true, message: '请输入活动详情', trigger: 'change' },
          { validator: checkFontNumber, trigger: 'blur' }
        ],
        addressSort3: [
          // { required: true, message: '请输入排序', trigger: 'change' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
          { min: 1, max: 4, message: '请输入1-9999之间的整数', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
      // console.log('this.$route.query.isView==', !!this.$route.query.isView)
    }
  },
  activated () {
    this.tinymceFlag++
  },
  methods: {
    ...mapRequestActions(SocietyActivityApi),
    handelConfirm (formName, type) {
      if (this.fileList && this.fileList.length > 0) {
        this.rule.uploadPic = []
        this.$refs.uploadPic.clearValidate()
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArrSort = []
          this.form.newsSortList.forEach(e => {
            if (e === '1') {
              newArrSort.push({ module: 1 })
            } else if (e === '2') {
              newArrSort.push({ module: 2 })
            } else if (e === '3') {
              newArrSort.push({ module: 3, sort: this.addressSort3 })
            } else if (e === '4') {
              newArrSort.push({ module: 4, sort: this.addressSort4 })
            } else if (e === '5') {
              newArrSort.push({ module: 5, sort: this.addressSort5 })
            } else if (e === '6') {
              newArrSort.push({ module: 6, sort: this.addressSort6 })
            } else if (e === '7') {
              newArrSort.push({ module: 7, sort: this.addressSort7 })
            } else if (e === '8') {
              newArrSort.push({ module: 8, sort: this.addressSort8 })
            } else if (e === '9') {
              newArrSort.push({ module: 9, sort: this.addressSort9 })
            } else if (e === '11') {
              newArrSort.push({ module: 11, sort: this.addressSort11 })
            } else if (e === '15') {
              // this.rule.uploadPic = []
              // this.$refs.uploadPic.clearValidate()
              newArrSort.push({ module: 15, sort: this.addressSort15 })
            }
          })

          const newArr = Object.assign(this.form,
            {
              institutionId: this.form.instititionArray ? this.form.instititionArray.join(',') : '',
              newsSortList: newArrSort,
              coverFileId: this.imageId,
              status: type
            }
          )

          // 编辑状态 且 点击 预发布
          if (newArrSort.length === 0) {
            this.$message.error('请在“显示位置”先勾选模块')
          } else {
            if (this.detailId && type === 2) {
              this.upDateSocietyActivityAction({
                ...newArr
              }).then((res) => {
                if (res.status) {
                  this.$message.success('编辑成功！')
                  this.$router.push('/society-activity')
                } else {
                  this.$message.error('操作失败')
                }
              })
            } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
              this.upDateSocietyActivityAction({
                ...newArr
              }).then((res) => {
                if (res.status) {
                  this.$message.success('保存成功！')
                  this.$router.push('/society-activity')
                } else {
                  this.$message.error('操作失败')
                }
              })
            } else {
              this.addSocietyActivityAction({
                ...newArr
              }).then((res) => {
                if (res.status) {
                  this.$message.success('新增成功！')
                  this.$router.push('/society-activity')
                } else {
                  this.$message.error('操作失败')
                }
              })
            }
          }
        } else {
          // todo
        }
      })
    },

    onChange (content, urls) {
      this.form.content = content
      this.form.newUrlStr = urls
      if (content) {
        this.$refs.form.validateField('content')
      }
    },
    /**
     * 根据ID 查询详情
     */
    async handleQueryDetailById () {
      const resultData = await this.queryDetailByIdAction({
        id: this.detailId,
        module: this.module
      })
      if (resultData.status) {
        this.form = resultData.result || []
        this.isStatus = resultData.result.status || null
        this.fileList.push({ name: this.form.title, url: Net.baseUrl + resultData.result.coverFile.relativePath })
        if (resultData.result.institutionId) {
          this.form.instititionArray = [...resultData.result.institutionId.split(',')]
        } else {
          this.form.instititionArray = []
        }
        resultData.result.newsSortList.forEach(e => {
          if (e.module === 1) {
            this.addressSort1 = ''
          } else if (e.module === 2) {
            this.addressSort2 = e.sort
          } else if (e.module === 3) {
            this.addressSort3 = e.sort
          } else if (e.module === 4) {
            this.addressSort4 = e.sort
          } else if (e.module === 5) {
            this.addressSort5 = e.sort
          } else if (e.module === 6) {
            this.addressSort6 = e.sort
          } else if (e.module === 7) {
            this.addressSort7 = e.sort
          } else if (e.module === 8) {
            this.addressSort8 = e.sort
          } else if (e.module === 9) {
            this.addressSort9 = e.sort
          } else if (e.module === 11) {
            this.addressSort11 = e.sort
          } else if (e.module === 15) {
            this.addressSort15 = e.sort
          }
        })
        this.form.newsSortList = resultData.result.newsSortList.map(item => {
          return item.module + ''
        })
      }
    },
    /**
     * 重置
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploadfiles1.clearFiles()
      this.fileList = []
      this.addressSort1 = ''
      this.addressSort2 = ''
      this.addressSort3 = ''
      this.addressSort4 = ''
      this.addressSort5 = ''
      this.addressSort6 = ''
      this.addressSort7 = ''
      this.addressSort8 = ''
      this.addressSort9 = ''
      this.addressSort11 = ''
      this.addressSort15 = ''
    },

    /**
     * handleRefresh 强制checkbox-group刷新
     */
    handleRefresh () {
      this.$forceUpdate()
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {

      } else {
        const index = this.fileList.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
        if (this.sendFile && this.sendFile.length === 0) {
          this.rule.uploadPic = [
            { required: true, message: '请上传图片', trigger: 'change' }
          ]
          this.$refs.form.validateField('uploadPic')
        }
      }
    },
    handleChange () {},

    handleBefore (file) {
      this.$refs.uploadPic.clearValidate()
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile = []
      that.fileList = []
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '图文信息')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId = res.result.id || ''
            that.linkUrl = res.result.thumbnailUrl || ''
          }
        })
        image.src = data
      }
      return false
    },

    handleExceed () {
      this.$message.warning('最多可以上传1张图片')
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 90%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 10px 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  .address {
    /deep/ .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 150px;
    float: left;
    // overflow: hidden;
    text-align: left;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
    .el-upload__tip{
      margin-top: 0;
      line-height: 26px;
      padding-bottom: 5px;
    }
  }
}

.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.select_button {
  float: left;
}
.el-col-6 {
  text-align: left;
  padding: 2px 0;
}

/deep/ .input_style {
  display: inline-block;
  padding-left: 4px;
  text-indent: 2px;
  width: 100px;
}
.el-col{
  text-align: left;
}
</style>
